import React from 'react'
import { withTranslation } from 'react-i18next' // 🌐 i18n HOC
import Alert from '../components/alerts/Alert'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    const { t } = this.props // i18n props

    if (this.state.hasError) {
      return (
        <Alert severity="error" sx={{ m: 2 }}>
          {t('errorBoundaryMessage')}
        </Alert>
      )
    }

    return this.props.children
  }
}

export default withTranslation('shared')(ErrorBoundary)
